const servermode = 'prod' // prod - Live | uat - test | prod = prodelopment
export default servermode
